import Path from "./Path";

export default Path;
